// extracted by mini-css-extract-plugin
module.exports = {"GrayBtn":"GrayBtn_GrayBtn__1fyrK","GrayBtnTxt":"GrayBtn_GrayBtnTxt__17URt"};